/**
 *
 * Asynchronously loads the component for ExercisesHome
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
